import {DEFAULT_LANGUAGE, SsoLanguagesConst} from '../../consts';

export const getSsoLocales = () => {
    const browserLang = (window.localStorage.i18nextLng || '')?.toLowerCase();
    return `ui_locales=${SsoLanguagesConst.includes(browserLang) ? browserLang : DEFAULT_LANGUAGE}`;
}
